import DiscountInfoModal from './DiscountInfoModal';

export default DiscountInfoModal;
